module.exports = __webpack_public_path__ + "static/media/logo-woocommerce-2.88240747.svg";